/* EYESHELLS collection toolbar, v1459 stability pass.
   Canonical runtime for sort dropdowns and responsive state.
   Grid density persistence is owned by es-collection-cols-persist.js. */
(function () {
  'use strict';

  if (window.__esCollectionToolbarCleanup) {
    try { window.__esCollectionToolbarCleanup(); } catch (error) {}
  }

  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  var narrowQuery = window.matchMedia ? window.matchMedia('(max-width: 389px)') : null;
  var lastTrigger = null;
  var resizeFrame = 0;
  var focusTimer = 0;
  var restoreFocusTimer = 0;
  var destroyed = false;

  function isMobile() {
    return mobileQuery ? mobileQuery.matches : (window.innerWidth || document.documentElement.clientWidth || 0) <= 767;
  }

  function isXL() {
    return (window.innerWidth || document.documentElement.clientWidth || 0) >= 1200;
  }

  function syncResponsiveSemantics() {
    var xl = isXL();
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    document.querySelectorAll('[data-es-responsive-controls]').forEach(function (element) {
      var mode = element.getAttribute('data-es-responsive-controls');
      var active = mode === 'xl' ? xl : mode === 'lt-xl' ? !xl : mode === 'lt-md' ? width < 768 : true;
      element.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) element.removeAttribute('inert');
      else element.setAttribute('inert', '');
    });
  }

  function syncDropdownMode(dropdown) {
    if (!dropdown) return;
    var mobile = isMobile();
    var toggle = getToggle(dropdown);
    var menu = getDesktopMenu(dropdown);
    var sheet = getMobileSheet(dropdown);
    if (toggle) {
      var target = mobile && sheet ? sheet : menu;
      if (target && target.id) toggle.setAttribute('aria-controls', target.id);
      toggle.setAttribute('aria-haspopup', mobile && sheet ? 'dialog' : 'menu');
    }
    if (sheet && !dropdown.classList.contains('es-mobile-sheet-open')) {
      sheet.setAttribute('aria-hidden', 'true');
      sheet.setAttribute('inert', '');
    }
  }

  function getResponsiveLabel(text) {
    var normalized = String(text || '').trim();
    var narrow = narrowQuery ? narrowQuery.matches : (window.innerWidth || 0) <= 389;
    if (narrow) {
      if (normalized === 'Price low to high') return 'Low to high';
      if (normalized === 'Price high to low') return 'High to low';
    }
    return normalized;
  }

  function getDropdowns() {
    return Array.prototype.slice.call(document.querySelectorAll('.collection-sorting [data-es-sort-dropdown]'));
  }

  function getToggle(dropdown) {
    return dropdown ? dropdown.querySelector('[data-es-sort-toggle]') : null;
  }

  function getDesktopMenu(dropdown) {
    return dropdown ? dropdown.querySelector(':scope > .dropdown-content') : null;
  }

  function getMobileSheet(dropdown) {
    return dropdown ? dropdown.querySelector(':scope > .es-mobile-sort-sheet') : null;
  }

  function getOptions(dropdown, mobile) {
    if (!dropdown) return [];
    var scope = mobile ? getMobileSheet(dropdown) : getDesktopMenu(dropdown);
    if (!scope) return [];
    return Array.prototype.slice.call(scope.querySelectorAll('[data-es-sort-value]'));
  }

  function getActiveOption(dropdown, mobile) {
    var options = getOptions(dropdown, mobile);
    for (var i = 0; i < options.length; i += 1) {
      if (options[i].getAttribute('aria-checked') === 'true') return options[i];
    }
    return options[0] || null;
  }

  function setOptionState(dropdown, value) {
    if (!dropdown || !value) return;
    var labelText = '';
    dropdown.querySelectorAll('[data-es-sort-value]').forEach(function (option) {
      var active = option.getAttribute('data-es-sort-value') === value;
      option.setAttribute('aria-checked', active ? 'true' : 'false');
      var item = option.closest('.sort-item');
      if (item) item.classList.toggle('active', active);
      if (active && !labelText) {
        var text = option.querySelector('.sort-text');
        labelText = text ? text.textContent.trim() : '';
      }
    });
    dropdown.setAttribute('data-es-current-sort', value);
    var label = dropdown.querySelector('.dropdown-label');
    var toggle = getToggle(dropdown);
    if (label && labelText) {
      label.textContent = getResponsiveLabel(labelText);
      label.setAttribute('data-es-full-label', labelText);
    }
    if (toggle && labelText) toggle.setAttribute('aria-label', 'Sort products. Current: ' + labelText);
  }

  function syncAll(value) {
    getDropdowns().forEach(function (dropdown) {
      setOptionState(dropdown, value || dropdown.getAttribute('data-es-current-sort') || 'manual');
    });
  }

  function setExpanded(dropdown, expanded, mode) {
    if (!dropdown) return;
    var mobile = mode === 'mobile';
    var toggle = getToggle(dropdown);
    var menu = getDesktopMenu(dropdown);
    var sheet = getMobileSheet(dropdown);

    dropdown.classList.toggle('es-sort-open', expanded && !mobile);
    dropdown.classList.toggle('es-mobile-sheet-open', expanded && mobile);
    if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (menu) menu.setAttribute('aria-hidden', expanded && !mobile ? 'false' : 'true');
    if (sheet) {
      var sheetOpen = expanded && mobile;
      sheet.setAttribute('aria-hidden', sheetOpen ? 'false' : 'true');
      if (sheetOpen) sheet.removeAttribute('inert');
      else sheet.setAttribute('inert', '');
      sheet.querySelectorAll('[data-es-sort-value]').forEach(function (option) {
        option.setAttribute('tabindex', sheetOpen ? '0' : '-1');
      });
    }
    syncDropdownMode(dropdown);
  }

  function closeAll(options) {
    options = options || {};
    if (focusTimer) window.clearTimeout(focusTimer);
    if (restoreFocusTimer) window.clearTimeout(restoreFocusTimer);
    focusTimer = 0;
    restoreFocusTimer = 0;
    getDropdowns().forEach(function (dropdown) { setExpanded(dropdown, false); });
    document.documentElement.classList.remove('es-mobile-sort-sheet-active');
    document.body.classList.remove('es-mobile-sort-sheet-active', 'es-sort-open-desktop');

    var restore = options.restoreFocus ? lastTrigger : null;
    lastTrigger = null;
    if (restore && restore.isConnected && !restore.disabled) {
      restoreFocusTimer = window.setTimeout(function () {
        restoreFocusTimer = 0;
        try { restore.focus({ preventScroll: true }); }
        catch (error) { try { restore.focus(); } catch (fallbackError) {} }
      }, 0);
    }
  }

  function openDropdown(dropdown, options) {
    options = options || {};
    if (!dropdown) return;
    closeAll();
    var mobile = isMobile();
    var toggle = getToggle(dropdown);
    lastTrigger = toggle;
    setExpanded(dropdown, true, mobile ? 'mobile' : 'desktop');

    if (mobile) {
      document.documentElement.classList.add('es-mobile-sort-sheet-active');
      document.body.classList.add('es-mobile-sort-sheet-active');
    } else {
      document.body.classList.add('es-sort-open-desktop');
    }

    if (options.focusMenu || mobile) {
      focusTimer = window.setTimeout(function () {
        focusTimer = 0;
        var target = getActiveOption(dropdown, mobile);
        if (!target) return;
        try { target.focus({ preventScroll: true }); }
        catch (error) { try { target.focus(); } catch (fallbackError) {} }
      }, 32);
    }
  }

  function navigateSort(value) {
    if (!value) return;
    var target = new URL(window.location.href);
    target.searchParams.set('sort_by', value);
    target.searchParams.delete('page');
    if (typeof window.ES_collectionNavigate === 'function') {
      window.ES_collectionNavigate(target, { push: true, scrollResults: true });
      return;
    }
    window.location.assign(target.toString());
  }

  function selectSortOption(option) {
    if (!option) return;
    var value = option.getAttribute('data-es-sort-value');
    if (!value) return;
    var dropdown = option.closest('[data-es-sort-dropdown]');
    var unchanged = dropdown && dropdown.getAttribute('data-es-current-sort') === value;
    syncAll(value);
    closeAll({ restoreFocus: !!unchanged });
    if (!unchanged) navigateSort(value);
  }

  function moveMenuFocus(option, direction) {
    var dropdown = option.closest('[data-es-sort-dropdown]');
    if (!dropdown) return;
    var options = getOptions(dropdown, isMobile());
    if (!options.length) return;
    var current = options.indexOf(option);
    var next = current;
    if (direction === 'first') next = 0;
    else if (direction === 'last') next = options.length - 1;
    else next = (current + direction + options.length) % options.length;
    options[next].focus({ preventScroll: true });
  }

  function onClick(event) {
    if (destroyed || !event.target || !event.target.closest) return;

    var toggle = event.target.closest('[data-es-sort-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var dropdown = toggle.closest('[data-es-sort-dropdown]');
      var open = dropdown && (dropdown.classList.contains('es-sort-open') || dropdown.classList.contains('es-mobile-sheet-open'));
      if (open) closeAll({ restoreFocus: false });
      else openDropdown(dropdown, { focusMenu: false });
      return;
    }

    var option = event.target.closest('[data-es-sort-value]');
    if (option && option.closest('.collection-sorting')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      selectSortOption(option);
      return;
    }

    var closeButton = event.target.closest('[data-es-mobile-sort-close]');
    if (closeButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeAll({ restoreFocus: true });
      return;
    }

    if (!event.target.closest('.collection-sorting [data-es-sort-dropdown]')) closeAll();
  }

  function onKeydown(event) {
    if (destroyed || !event.target || !event.target.closest) return;

    if (event.key === 'Tab') {
      var openMobileDropdown = event.target.closest('[data-es-sort-dropdown].es-mobile-sheet-open');
      var openSheet = getMobileSheet(openMobileDropdown);
      if (openSheet) {
        var sheetFocusables = Array.prototype.slice.call(openSheet.querySelectorAll('button:not([disabled])')).filter(function (button) {
          return button.getAttribute('aria-hidden') !== 'true' && button.getAttribute('tabindex') !== '-1';
        });
        if (sheetFocusables.length) {
          var sheetFirst = sheetFocusables[0];
          var sheetLast = sheetFocusables[sheetFocusables.length - 1];
          if (event.shiftKey && document.activeElement === sheetFirst) {
            event.preventDefault();
            sheetLast.focus({ preventScroll: true });
            return;
          }
          if (!event.shiftKey && document.activeElement === sheetLast) {
            event.preventDefault();
            sheetFirst.focus({ preventScroll: true });
            return;
          }
        }
      }
    }

    var toggle = event.target.closest('[data-es-sort-toggle]');
    if (toggle) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        openDropdown(toggle.closest('[data-es-sort-dropdown]'), { focusMenu: true });
      } else if (event.key === 'Escape') {
        event.preventDefault();
        closeAll({ restoreFocus: true });
      }
      return;
    }

    var option = event.target.closest('[data-es-sort-value]');
    if (option && option.closest('.collection-sorting')) {
      if (event.key === 'ArrowDown') { event.preventDefault(); moveMenuFocus(option, 1); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); moveMenuFocus(option, -1); }
      else if (event.key === 'Home') { event.preventDefault(); moveMenuFocus(option, 'first'); }
      else if (event.key === 'End') { event.preventDefault(); moveMenuFocus(option, 'last'); }
      else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        selectSortOption(option);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        closeAll({ restoreFocus: true });
      }
      return;
    }

    if (event.key === 'Escape' && document.querySelector('.collection-sorting .es-sort-open, .collection-sorting .es-mobile-sheet-open')) {
      event.preventDefault();
      closeAll({ restoreFocus: true });
    }
  }

  function onFocusIn(event) {
    if (!document.querySelector('.collection-sorting .es-sort-open')) return;
    if (!event.target.closest('.collection-sorting [data-es-sort-dropdown]')) closeAll();
  }

  function refreshLabels() {
    syncResponsiveSemantics();
    getDropdowns().forEach(function (dropdown) {
      setOptionState(dropdown, dropdown.getAttribute('data-es-current-sort') || 'manual');
      syncDropdownMode(dropdown);
    });
  }

  function onViewportChange() {
    if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(function () {
      resizeFrame = 0;
      closeAll();
      refreshLabels();
    });
  }

  function onCollectionUpdated() {
    closeAll();
    refreshLabels();
  }

  function onPageHide() {
    if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
    resizeFrame = 0;
    closeAll();
  }

  function onPageShow() {
    if (destroyed) return;
    closeAll();
    refreshLabels();
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('keydown', onKeydown, true);
  document.addEventListener('focusin', onFocusIn, true);
  document.addEventListener('es:collection:updated', onCollectionUpdated);
  window.addEventListener('resize', onViewportChange, { passive: true });
  window.addEventListener('orientationchange', onViewportChange, { passive: true });
  window.addEventListener('pagehide', onPageHide);
  window.addEventListener('pageshow', onPageShow);

  closeAll();
  refreshLabels();

  window.__esCollectionToolbarCleanup = function () {
    destroyed = true;
    document.removeEventListener('click', onClick, true);
    document.removeEventListener('keydown', onKeydown, true);
    document.removeEventListener('focusin', onFocusIn, true);
    document.removeEventListener('es:collection:updated', onCollectionUpdated);
    window.removeEventListener('resize', onViewportChange);
    window.removeEventListener('orientationchange', onViewportChange);
    window.removeEventListener('pagehide', onPageHide);
    window.removeEventListener('pageshow', onPageShow);
    if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
    if (focusTimer) window.clearTimeout(focusTimer);
    if (restoreFocusTimer) window.clearTimeout(restoreFocusTimer);
    resizeFrame = 0;
    focusTimer = 0;
    restoreFocusTimer = 0;
    closeAll();
  };
}());
